import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataKlinik, DataKlinikV2 } from '../../models/data-klinik.model';
import { DataKlinikApiService } from '../api/data-klinik.api.service';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class DataKlinikDataService implements DataService<DataKlinik> {
  public isLoadingSubject: BehaviorSubject<boolean>;
  public isLoading$: Observable<boolean>;

  constructor(private dataKlinikApiService: DataKlinikApiService) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  public getAll(params?: { signature: string }): Observable<DataKlinikV2[]> {
    return this.dataKlinikApiService.getAll(params);
  }

  public getById(idDataKlinik?: number, params?: { signature: string }): Observable<DataKlinikV2> {
    return this.dataKlinikApiService.getById(idDataKlinik, params);
  }

  public getByUrl(url: string): Observable<DataKlinikV2> {
    return this.dataKlinikApiService.getByUrl(url);
  }

  public getByCustomerCode(code: string): Observable<DataKlinikV2> {
    return this.dataKlinikApiService.getByCustomerCode(code);
  }

  public getDataHeadOffice(idGroupDataKlinik: number): Observable<DataKlinikV2> {
    return this.dataKlinikApiService.getDataHeadOffice(idGroupDataKlinik);
  }

  public create(data: any, signature?: string): Observable<number> {
    return this.dataKlinikApiService.create(data, signature);
  }

  public createNewClinic(data: any, signature?: string): Observable<any> {
    return this.dataKlinikApiService.createNewClinic(data, signature);
  }

  public update(data: any): Observable<any> {
    return this.dataKlinikApiService.update(data);
  }
}
